export const AWS_CAPTCHA_CONTAINER_ID = 'aws-captcha-container';

export const AWS_CAPTCHA_SCRIPT_ID = 'aws-captcha-jsapi';
